import { spacing } from '@lamimed/pantheon';

import * as S from '../../styles';

export type Spacing = keyof typeof spacing;

import { ColumnRowProps } from '../ColumnRow';

export const Row = ({
  icon,
  children,
  marginBottom,
  marginTop,
  justifyContent,
}: React.PropsWithChildren<
  Omit<ColumnRowProps, 'head' | 'headVerticalAlignment'>
>) => {
  return (
    <S.ColumnRowWrapper
      marginBottom={marginBottom}
      marginTop={marginTop}
      justifyContent={justifyContent}
      headVerticalAlignment="center"
    >
      {icon}

      {children}
    </S.ColumnRowWrapper>
  );
};
